import { createSelector } from 'reselect'

import { selectQbrState } from './selectQbrState'

export const selectQbrIsLegacyDocument = createSelector(
  [selectQbrState],
  ({ isLegacyDocument }) => isLegacyDocument
)
